import { PropsWithChildren, useEffect, useState } from 'react';
import { useTheme } from '@tcc-online/react-theme-provider';
import { css, cx } from '@emotion/css';

import {
    PRIMARY_360_COLOR,
    PRIMARY_COLOR,
    PRIMARY_PRUZKUM_COLOR,
    SECONDARY_360_COLOR,
    SECONDARY_COLOR,
} from '../../../constants/pallete.constants';
import useIconAsset from '../../../hooks/useIconAsset';
import {
    QUESTIONNAIRE_360_TYPE,
    QUESTIONNAIRE_PRUZKUM_TYPE,
    QUESTIONNAIRE_PSYCHODIAGNOSTIKA_TYPE,
} from '../../../constants/questionnaireTypes.constants';
import styles from './BaseProjectCard.module.scss';

type BaseProjectCardProps = PropsWithChildren<{
    name: string;
    iconName: string;
    type: number;
    subtype: number;
    onClick?: () => void;
    disabled?: boolean;
}>;

export default function BaseProjectCard(props: BaseProjectCardProps) {
    const { type, subtype, name, iconName, children, onClick, disabled } =
        props;

    const [color, setColor] = useState<string>(PRIMARY_COLOR);
    const [theme] = useTheme();
    const { asset } = useIconAsset(`${iconName}_borderless.svg`);

    useEffect(() => {
        switch (type) {
            case QUESTIONNAIRE_PSYCHODIAGNOSTIKA_TYPE:
                if (subtype === 0) {
                    setColor(PRIMARY_COLOR);
                } else {
                    setColor(SECONDARY_COLOR);
                }
                break;
            case QUESTIONNAIRE_PRUZKUM_TYPE:
                setColor(PRIMARY_PRUZKUM_COLOR);
                break;
            case QUESTIONNAIRE_360_TYPE:
                if (subtype === 1) {
                    setColor(SECONDARY_360_COLOR);
                } else {
                    setColor(PRIMARY_360_COLOR);
                }
                break;
            default:
                setColor(PRIMARY_COLOR);
        }
    }, [type, subtype]);

    return (
        <div
            className={cx(
                styles.card,
                disabled && styles.disabled,
                css({
                    background: disabled ? theme.disabledColor : color,
                    color: theme.textLightColor,
                }),
            )}
            onClick={handleClick}
        >
            <div className={styles.card__name}>{name}</div>
            <div className={styles.card__icon}>
                <img src={asset} alt="" />
            </div>
            {children}
        </div>
    );

    function handleClick() {
        if (disabled !== true) {
            onClick?.();
        }
    }
}
